export function downloadFile(
  data: BlobPart,
  format: string | null,
  name: string | null,
) {
  const newName = name ? name.replaceAll('"', "'") : '';
  const a = document.createElement('a');
  const blob = new Blob([data], {
    type: 'application/octet-stream;charset=UTF-8',
  });
  const url = window.URL.createObjectURL(blob);
  a.href = url;
  a.download = format ? `${newName}.${format.toLocaleLowerCase()}` : newName;
  a.click();
  window.URL.revokeObjectURL(url);
}

export function downloadFileZipFile(data: BlobPart, format: string, name: string) {
  const blob = data instanceof Blob ? data : new Blob([data], { type: 'application/octet-stream' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${name}.${format.toLowerCase()}`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}



export function extractFilenameFromContentDisposition(contentDisposition: string): string {
  if (!contentDisposition) return 'download.xlsx';
  
  let filename = 'download.xlsx';
  
  const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8Match && utf8Match[1]) {
    try {
      filename = decodeURIComponent(utf8Match[1]);
      return filename;
    } catch (e) {
      console.warn('Failed to decode UTF-8 filename:', e);
    }
  }
  
  const isoMatch = contentDisposition.match(/filename\*=([^;]+)/i);
  if (isoMatch && isoMatch[1]) {
    const parts = isoMatch[1].split("''");
    if (parts.length > 1) {
      filename = parts.slice(1).join("''");
    }
    return filename;
  }
  
  const quotedMatch = contentDisposition.match(/filename="([^"]+)"/i);
  if (quotedMatch && quotedMatch[1]) {
    filename = quotedMatch[1];
    return filename;
  }
  
  const unquotedMatch = contentDisposition.match(/filename=([^;]+)/i);
  if (unquotedMatch && unquotedMatch[1]) {
    filename = unquotedMatch[1];
    return filename;
  }
  
  return filename;
}
